import { format } from "date-fns";
import axiosInstance from "../config/AuthInterceptors";
import { IBeehiveBody, IBeehiveGenericResponse, IBeehiveGetListResponse } from "../interfaces/beehive";
import { IExportStat } from "../interfaces/beehiveStats";
import utilsService from "./utilsService";

const BASE_URL = process.env.REACT_APP_API_URL

const beehiveService = {
    getAll: (skip: number = 0, limit: number = 25) => axiosInstance.get<IBeehiveGetListResponse>("/beehouses?restrictVisibilityTo=beeTogether&skip=" + skip + "&limit=" + limit).then(res => res.data),
    get: (id: string) => axiosInstance.get<IBeehiveGenericResponse>("/beehouses/" + id).then(res => res.data),
    post: (body: IBeehiveBody) => axiosInstance.post<IBeehiveGenericResponse>("/beehouses", body).then(res => res.data),
    put: (id: string, body: IBeehiveBody) => axiosInstance.put<IBeehiveGenericResponse>("/beehouses/" + id, body).then(res => res.data),
    delete: (id: string) => axiosInstance.delete<IBeehiveGenericResponse>("/beehouses/" + id).then(res => res.data),
    downloadCSV: (source: "manual" | "import", params?: IExportStat) => {
        let fieldsToExport: string[] = []
        let houseIdsFields: string[] = []
        let url = '';

        if (params) {
            Object.keys(params).forEach(
                key => {
                    if (typeof params[key as keyof IExportStat] === "boolean" && params[key as keyof IExportStat] === true) {
                        fieldsToExport.push("&fieldsToExport=" + key.slice(0, 1).toUpperCase() + key.slice(1))
                    }
                    if (typeof params[key as keyof IExportStat] === "object")
                        (params[key as keyof IExportStat] as string[]).forEach(element => {
                            if (element !== '' && element !== 'select-all')
                                houseIdsFields.push("&houseIds=" + element)
                        });
                }
            )

            const fields = fieldsToExport.length > 0 ? fieldsToExport.join("") : undefined
            const houseIds = houseIdsFields.length > 0 ? houseIdsFields.join("") : undefined

            url = `${BASE_URL}/beehouses/stats/all?source=${source}${houseIds}&exportAs=csv&from=${format(params.from, "yyyy-MM-dd HH:mm")}&to=${format(params.to, "yyyy-MM-dd HH:mm")}${fields}`;
        } else {
            url = `${BASE_URL}/beehouses/stats/all?source=${source}&exportAs=csv`;
        }

        return utilsService.downloadFileFromMemory(url);
    }
}

export default beehiveService;